import { Text } from '@uhg-abyss/web/ui/Text';
import { getEEMSURL } from '@src/env.config';

export const CustomError = ({ error }) => {
  return (
    <Text
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '5px',
        width: '100%',
      }}
    >
      <br />
      <Text
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          color: 'red',
          fontWeight: 'bold',
          fontSize: '18px',
          height: '50vh',
        }}
      >
        {error || ''}
        <a href="mailto:E3_OM_DL@ds.uhc.com"> E3_OM_DL@ds.uhc.com</a>
      </Text>
    </Text>
  );
};
